import { EmergencyQuestionValue } from '@dte/otw-azure-functions/src/report/questions/problemType/EmergencyQuestion';
import { ProblemTypeQuestionValue } from '@dte/otw-azure-functions/src/report/questions/problemType/ProblemTypeQuestion';
import { ReportQuestion } from '@dte/otw-azure-functions/src/report/questions/ReportQuestion';
import { useReportAnswerValueSelected } from '../../../_atoms/draftReport/stepData';
import { ReportStep } from '../../../ReportSteps';

export function useIsTrappedContact(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.TrappedContact);
}

export function useIsPowerLine(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.PowerLine);
}

export function useIsPower(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Power);
}

export function useIsHazard(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Hazard);
}

export function useIsEquipment(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Equipment);
}

export function useIsTree(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Tree);
}

export function useIsPoleDebris(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.ProblemType, ProblemTypeQuestionValue.Pole);
}

export function useIsArcing(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Arcing);
}
export function useIsContactWithEquipment(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Contact);
}

export function useIsFire(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Fire);
}
export function useIsInjuries(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Injuries);
}
export function useIsPublicTrapped(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.Emergencies, EmergencyQuestionValue.Trapped);
}

export function useSafetyNextStep(): ReportStep[] {
	const potentialSteps = [
		useIsTrappedContact() ? ReportStep.TrappedContact : undefined,
		useIsPowerLine() ? ReportStep.PowerLine : undefined,
		useIsPower() ? ReportStep.Power : undefined,
		useIsHazard() ? ReportStep.Hazard : undefined,
		useIsEquipment() ? ReportStep.EquipmentProblem : undefined,
		useIsTree() ? ReportStep.Tree : undefined,
		useIsPoleDebris() ? ReportStep.PoleDebris : undefined,
	];

	return potentialSteps;
}

export function useIsEmergency(): boolean {
	const possibleSteps = [useIsContactWithEquipment(), useIsPublicTrapped(), useIsFire(), useIsArcing()];
	return possibleSteps.includes(true);
}
